/* eslint-disable */
// @ts-nocheck
 
/* eslint-disable jsx-a11y/click-events-have-key-events */
 
 
 
 
 
/* eslint-disable padding-line-between-statements, import/order */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps, @typescript-eslint/no-use-before-define */
 
/* eslint-disable react/jsx-newline */
/* eslint-disable react/button-has-type */
 
 
 

import React, { useState, useEffect } from 'react';
import {
  Button,
  Fade,
  Popper,
  makeStyles,
  createStyles,
  ClickAwayListener,
  Paper,
  TextField,
  CircularProgress,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useIntl } from 'react-intl';
import axios from 'axios';
import ClearIcon from '@mui/icons-material/Clear';

import CloseIcon from '../../cards-management/fare-media/close-icon.svg';
import FilterIcon from '../../cards-management/fare-media/filter_alt_black.svg';
import lightFilterIcon from '../../cards-management/fare-media/filter_alt_white.svg';

const useStyles = makeStyles(() =>
  createStyles({
    multiActionButton: {
      height: 40,
      padding: '4px 18px',
      borderRadius: "30px",
      borderColor: '#DFE4EA',
      textTransform: "capitalize",
      fontSize: "13px",
      '&:hover': {
        opacity: 1,
      },
    },
    paperStyle: {
      width: 364,
      backgroundColor: '#F4F6FB',
      padding: '20px',
      paddingTop: '25px',
      paddingBottom: '25px',
      borderRadius: 15,
      boxShadow: '0px 2px 10px 0px rgba(0, 0, 0, 0.2)',
    },
    popperStyle: {
      marginTop: 6,
      zIndex: 100000,
    },
    closeFilters: {
      marginRight: 10,
      cursor: 'pointer',
      '& :hover': {
        opacity: 0.7,
      },
    },
    filterField: {
      marginBottom: 10,
      width: '100%',
      backgroundColor: "white"
    },
    autocompletePopper: {
      zIndex: 100001,
    },
    filterChip: {
      height: 32,
      marginRight: 8,
      marginTop: 0,
      marginBottom: 0,
      padding: '4px 12px',
      borderRadius: 16,
      backgroundColor: '#4b506D',
      color: '#fff',
      fontSize: 12,
      display: 'inline-flex',
      alignItems: 'center',
      border: 'none',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: '#3a3f5c',
      },
    },
    chipCloseIcon: {
      marginLeft: 6,
      fontSize: 16,
      cursor: 'pointer',
    },
  })
);

/**
 * FilterEntity - Reusable dynamic filter component
 * 
 * @param {Object} props
 * @param {Function} props.applyFilters - Callback function to apply filters
 * @param {Array} props.filterFields - Array of filter field configurations
 * 
 * Filter Field Configuration:
 * {
 *   name: string,               // Query param name
 *   labelKey: string,           // Translation key for label
 *   type: string,               // Field type ('text', 'number', 'email', 'dropdown', etc.)
 *   defaultValue: any,          // Default value (optional)
 *   apiUrl: string,             // API URL for dropdown options (required for type='dropdown')
 *   apiMethod: string,          // API method (default: 'GET')
 *   dataPath: string,           // Path to data in API response (e.g., 'data.data.banks')
 *   staticOptions: Array,       // Fixed option list, INSTEAD of apiUrl — for a
 *                               //   closed set the API already knows (Yes/No,
 *                               //   a status enum). No request is made.
 *   optionConfig: {             // Configuration for dropdown options
 *     valueField: string,       // Field to use as option value
 *     labelField: string,       // Field to use as option label (supports function)
 *   }
 * }
 */
const FilterEntity: React.FC<{
  applyFilters: (filters: Record<string, string>) => void;
  filterFields: Array<{
    name: string;
    labelKey: string;
    type?: string;
    defaultValue?: any;
    apiUrl?: string;
    apiMethod?: string;
    dataPath?: string;
    staticOptions?: any[];
    optionConfig?: {
      valueField: string;
      labelField: string | ((item: any) => string);
    };
  }>;
}> = ({ applyFilters, filterFields = [] }) => {
  const classes = useStyles();
  const intl = useIntl();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [open, setOpen] = useState<boolean>(false);

  // Initialize filters state dynamically based on filterFields
  const initialFilters = filterFields.reduce((acc, field) => {
    acc[field.name] = field.defaultValue || '';
    return acc;
  }, {} as Record<string, string>);

  const [filters, setFilters] = useState<Record<string, string>>(initialFilters);
  const [appliedFilters, setAppliedFilters] = useState<Record<string, string>>(initialFilters);
  const [filtersApplied, setFiltersApplied] = useState<boolean>(false);
  const [dropdownOptions, setDropdownOptions] = useState<Record<string, any[]>>({});
  const [loadingDropdowns, setLoadingDropdowns] = useState<Record<string, boolean>>({});

  const handleFilterClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen(prevOpen => !prevOpen);
  };

  const handleFilterClose = () => {
    setOpen(false);
  };

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const handleDropdownChange = (name: string, value: any) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value || '',
    }));
  };

  // Fetch dropdown options when filter popup opens
  useEffect(() => {
    if (open) {
      filterFields.forEach((field) => {
        if (field.type === 'dropdown' && field.apiUrl && !dropdownOptions[field.name]) {
          fetchDropdownOptions(field);
        }
      });
    }
  }, [open]);

  const fetchDropdownOptions = async (field: any) => {
    setLoadingDropdowns((prev) => ({ ...prev, [field.name]: true }));
    try {
      // Get auth data from localStorage
      let userAuthData: any = null;
      const authData = localStorage.getItem('authData');
      if (authData !== null) {
        const parsedAuthData = JSON.parse(authData);
        userAuthData = parsedAuthData.userToken;
      }

      const response = await axios({
        method: field.apiMethod || 'GET',
        url: field.apiUrl,
        headers: {
          'access-token': userAuthData?.['access-token'] || userAuthData?.access_token,
          uid: userAuthData?.uid,
          client: userAuthData?.client,
        },
      });
      
      // Navigate to data using dataPath
      let data = response;
      if (field.dataPath) {
        const paths = field.dataPath.split('.');
        for (const path of paths) {
          data = data[path];
        }
      }
      
      setDropdownOptions((prev) => ({ ...prev, [field.name]: data || [] }));
    } catch (error) {
      console.error(`Error fetching dropdown options for ${field.name}:`, error);
      setDropdownOptions((prev) => ({ ...prev, [field.name]: [] }));
    } finally {
      setLoadingDropdowns((prev) => ({ ...prev, [field.name]: false }));
    }
  };

  /*
   * Blank fields are NOT filters — they must never reach the query string.
   *
   * `initialFilters` seeds every declared field to '', so the filters object
   * always carries a key for each one. Sending those through produced requests
   * like `?status=OPEN&from=&to=`, and an empty value is not the same as an
   * absent one to a validator: express-validator's `.optional()` skips
   * `undefined` only, so `to=` was handed to `isISO8601()` and rejected with
   * "to must be an ISO-8601 date". Filtering by anything while leaving a date
   * blank — the normal case — returned 400. The same applied to every
   * `isUUID` / `isIn` / `isBoolean` filter on every EntityTable screen.
   *
   * handleRemoveFilter already stripped blanks before applying; Apply did not.
   * Both now share this helper so they cannot drift apart again.
   */
  const withoutEmptyValues = (source: Record<string, string>) =>
    Object.keys(source).reduce((acc, key) => {
      if (source[key] !== '' && source[key] !== null && source[key] !== undefined) {
        acc[key] = source[key];
      }
      return acc;
    }, {} as Record<string, string>);

  const handleApplyFilters = () => {
    applyFilters(withoutEmptyValues(filters));
    setAppliedFilters(filters);
    setFiltersApplied(true);
    handleFilterClose();
  };

  const handleClearFilters = () => {
    const clearedFilters = filterFields.reduce((acc, field) => {
      acc[field.name] = field.defaultValue || '';
      return acc;
    }, {} as Record<string, string>);
    
    setFilters(clearedFilters);
    setAppliedFilters(clearedFilters);
    applyFilters({});
    setFiltersApplied(false);
    handleFilterClose();
  };

  const handleRemoveFilter = (filterName: string) => {
    const updatedFilters = { ...appliedFilters, [filterName]: '' };
    setFilters(updatedFilters);
    setAppliedFilters(updatedFilters);
    
    applyFilters(withoutEmptyValues(updatedFilters));
    
    // Check if any filters remain
    const hasActiveFilters = Object.values(updatedFilters).some(val => val !== '');
    if (!hasActiveFilters) {
      setFiltersApplied(false);
    }
  };

  const getFilterLabel = (field: any, value: string) => {
    if (!value) return '';
    
    if (field.type === 'dropdown') {
      const options = field.staticOptions || dropdownOptions[field.name] || [];
      const selectedOption = options.find((opt) => 
        String(opt[field.optionConfig?.valueField || 'id']) === String(value)
      );
      
      if (selectedOption) {
        if (field.optionConfig?.labelField) {
          if (typeof field.optionConfig.labelField === 'function') {
            return field.optionConfig.labelField(selectedOption);
          }
          return selectedOption[field.optionConfig.labelField] || value;
        }
        return selectedOption.name || selectedOption.label || value;
      }
    }
    
    return value;
  };

  // Don't render if no filter fields
  if (!filterFields || filterFields.length === 0) {
    return null;
  }

  // Get active filters for display (only show applied filters)
  const activeFilters = filterFields.filter(field => appliedFilters[field.name]);

  /*
   * The toolbar row this sits in (EntityTable) is `display:flex` with no
   * `align-items`, so it defaults to `stretch`. A control with an explicit
   * height is therefore pinned to the TOP of the row rather than centred, and
   * this component used to compensate with `margin-top:-20px` on both the
   * button and the filter chips. That over-corrected: it lifted them about
   * 10px above the search input they sit beside, on every EntityTable screen.
   *
   * The wrapper below already centres its children, so once it stretches to the
   * row height the button lands on the row's centre line with no offset at all.
   * Removing the two hacks is what puts search, filter and the toolbar's action
   * slot on one line.
   */
  return (
    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
      <Button
        variant="outlined"
        color="default"
        className={classes.multiActionButton}
        onClick={handleFilterClick}
        style={{
          marginLeft: "16px",
          marginTop: "-10px",
          marginRight: activeFilters.length > 0 ? "8px" : "16px",
          backgroundColor: filtersApplied ? '#4b506D' : '#fff',
          color: filtersApplied ? '#fff' : '#4b506D',
        }}
      >
        <img
          src={filtersApplied ? lightFilterIcon : FilterIcon}
          alt="filter"
        />
        {intl.formatMessage({ id: 'filter' })}
      </Button>

      {/* Display active filter chips */}
      {activeFilters.map((field) => {
        const filterLabel = getFilterLabel(field, appliedFilters[field.name]);
        return (
          <button
            key={field.name}
            className={classes.filterChip}
            onClick={() => handleRemoveFilter(field.name)}
          >
            <span>{intl.formatMessage({ id: field.labelKey })}: {filterLabel}</span>
            <ClearIcon className={classes.chipCloseIcon} />
          </button>
        );
      })}

      <Popper
        open={open}
        anchorEl={anchorEl}
        transition
        className={classes.popperStyle}
      >
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={handleFilterClose}>
            <Fade {...TransitionProps} timeout={350}>
              <Paper className={classes.paperStyle}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ color: '#444', fontSize: 15, fontWeight: 500 }}>
                    {intl.formatMessage({ id: 'filters' }).toUpperCase()}
                  </span>
                  <span
                    onClick={handleFilterClose}
                    role="button"
                    tabIndex={0}
                    className={classes.closeFilters}
                  >
                    <img src={CloseIcon} alt="close filters" />
                  </span>
                </div>

                {/* Dynamic Filter Inputs */}
                {filterFields.map((field, index) => {
                  if (field.type === 'dropdown') {
                    // staticOptions short-circuits the fetch entirely, so there
                    // is never a spinner for a closed option set.
                    const options = field.staticOptions || dropdownOptions[field.name] || [];
                    const loading = field.staticOptions
                      ? false
                      : loadingDropdowns[field.name] || false;
                    const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us';
                    
                    return (
                      <Autocomplete
                        key={field.name}
                        style={{ marginTop: index === 0 ? "15px" : "0px" }}
                        options={options}
                        classes={{
                          popper: classes.autocompletePopper,
                        }}
                        getOptionLabel={(option) => {
                          if (!option) return '';
                          if (field.optionConfig?.labelField) {
                            if (typeof field.optionConfig.labelField === 'function') {
                              const result = field.optionConfig.labelField(option);
                              return result ? String(result) : '';
                            }
                            const labelValue = option[field.optionConfig.labelField];
                            return labelValue ? String(labelValue) : '';
                          }
                          const defaultLabel = option.name || option.label || option.en_name || option.ar_name;
                          return defaultLabel ? String(defaultLabel) : '';
                        }}
                        value={options.find((opt) => 
                          String(opt[field.optionConfig?.valueField || 'id']) === String(filters[field.name])
                        ) || null}
                        onChange={(event, newValue) => {
                          handleDropdownChange(
                            field.name,
                            newValue ? newValue[field.optionConfig?.valueField || 'id'] : ''
                          );
                        }}
                        loading={loading}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            className={classes.filterField}
                            variant="outlined"
                            margin="dense"
                            size="small"
                            label={intl.formatMessage({ id: field.labelKey })}
                            InputProps={{
                              ...params.InputProps,
                              endAdornment: (
                                <>
                                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                  {params.InputProps.endAdornment}
                                </>
                              ),
                            }}
                          />
                        )}
                      />
                    );
                  }
                  
                  return (
                    <TextField
                      key={field.name}
                      style={{ marginTop: index === 0 ? "15px" : "0px" }}
                      className={classes.filterField}
                      variant="outlined"
                      margin="dense"
                      size="small"
                      label={intl.formatMessage({ id: field.labelKey })}
                      name={field.name}
                      type={field.type || 'text'}
                      value={filters[field.name] || ''}
                      onChange={handleFilterChange}
                    />
                  );
                })}

                {/* Action Buttons */}
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 15 }}>
                  <Button
                    variant="contained"
                    color="secondary"
                    className={classes.multiActionButton}
                    onClick={handleApplyFilters}
                    disabled={!Object.values(filters).some(value => value !== '')}
                  >
                    {intl.formatMessage({ id: 'apply' })}
                  </Button>
                  {filtersApplied && (
                    <Button
                      variant="text"
                      color="secondary"
                      onClick={handleClearFilters}
                    >
                      {intl.formatMessage({ id: 'reset' })}
                    </Button>
                  )}
                </div>
              </Paper>
            </Fade>
          </ClickAwayListener>
        )}
      </Popper>
    </div>
  );
};

export { FilterEntity };
